import { makeObservable, observable, action } from 'mobx';

export type EnduranceType =
  | 'lessThanMailbox'
  | 'endOfBlock'
  | 'oneMile'
  | 'twoOrThreeMiles'
  | 'longWay';

export class EnduranceStore {
  selectedEndurance: EnduranceType | null = null;

  constructor() {
    makeObservable(this, {
      selectedEndurance: observable,
      setEndurance: action,
    });
  }

  setEndurance(inputEndurance: EnduranceType) {
    this.selectedEndurance = inputEndurance;
  }
}

export const enduranceStore = new EnduranceStore();
